import { ErrorMessage, Field, FieldArrayRenderProps } from 'formik';
import FormikFieldLabelAutoComplete from '../../../../utils/FormikFieldLabelAutoComplete';
import Input from '../Input/Input';
import FormikFormInput from '../../../../utils/FormikFormInput';

function LabelShoppingCenterComponent({
  props,
  arrayHelpers,
}: {
  props: any;
  arrayHelpers: FieldArrayRenderProps;
}) {
  let details = {
    address: '',
    name: '',
    distance: '',
  };

  return (
    <div>
      {props.values.nearBy.propertyShoppingCentersDetails?.map(
        (_: any, index: number) => (
          <div key={index} className="row align-items-end mt-3">
            <div className="col">
              <div className="row">
                <div className="col">
                  {/* <Field
                    type="text"
                    name={`nearBy.propertyShoppingCentersDetails[${index}].address`}
                    placeholder=""
                    autoComplete="off"
                    className={`form-control `}
                    label="Address"
                    addressType="shopping_mall"
                    as={FormikFormInput}
                  /> */}
                  {/* <ErrorMessage
                    component="div"
                    name={`nearBy.propertyShoppingCentersDetails[${index}].address`}
                    className="invalid-feedback"
                  /> */}
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-7">
                  <Field
                    type="text"
                    name={`nearBy.propertyShoppingCentersDetails[${index}].address`}
                    placeholder="Name"
                    autoComplete="off"
                    className={`form-control `}
                    // as={FormikFieldLabelAutoComplete}
                    label="Name"
                    addressType="shopping_mall"
                    as={FormikFormInput}
                  />
                  {/* <ErrorMessage
                    component="div"
                    name={`nearBy.propertyShoppingCentersDetails[${index}].name`}
                    className="invalid-feedback"
                  /> */}
                </div>
                <div className="col-3 px-0">
                  <Field
                    type="number"
                    name={`nearBy.propertyShoppingCentersDetails[${index}].distance`}
                    placeholder="KM"
                    autoComplete="off"
                    className={`form-control `}
                    label="KM"
                    as={FormikFormInput}
                  />
                  {/* <ErrorMessage
                    component="div"
                    name={`nearBy.propertyShoppingCentersDetails[${index}].distance`}
                    className="invalid-feedback"
                  /> */}
                </div>

                <div className="col-2">
                  {index ===
                    props.values.nearBy.propertyShoppingCentersDetails?.length -
                    1 && (
                      <div className="d-flex align-items-end gap-2 pb-2">
                        {props.values.nearBy.propertyShoppingCentersDetails
                          ?.length > 1 ? (
                          <button
                            className="rounded-full bg-light border d-flex align-items-center justify-content-center rounded-5 fs-4"
                            style={{
                              width: '25px',
                              height: '25px',
                              paddingBottom: '5px',
                            }}
                            onClick={() => {
                              if (
                                props.values.nearBy.propertyShoppingCentersDetails
                                  ?.length >= 2
                              ) {
                                arrayHelpers.remove(index);
                              } else {
                                props.values.nearBy.propertyShoppingCentersDetails[0] =
                                  details;
                                props.values.nearBy.propertyHealthAndMedical =
                                  false;
                              }
                            }}
                          >
                            -
                          </button>
                        ) : null}

                        <button
                          className="rounded-full bg-light border d-flex align-items-center justify-content-center rounded-5 fs-6"
                          style={{
                            width: '25px',
                            height: '25px',
                            paddingBottom: '5px',
                          }}
                          onClick={() => arrayHelpers.push(details)}
                        >
                          +
                        </button>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
}

export default LabelShoppingCenterComponent;
